import { Injectable } from '@angular/core';

import { BondedStockTransactionType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class BondedStockTransactionTypeService extends TmsWebBaseEditService<
  BondedStockTransactionType,
  BondedStockTransactionType
> {
  constructor() {
    super('BondedStockTransactionType', $localize`Bonded Stock Transaction Type`);
  }
}
